(() => {
  const ROOT_SELECTOR = '[data-tutorial-video-slider]';

  const initializePreview = (preview) => {
    if (preview.dataset.initialized) return;
    const link = preview.querySelector('[data-tutorial-youtube-play]');
    const template = preview.querySelector('template');
    if (!link || !template) return;
    preview.dataset.initialized = 'true';
    const image = preview.querySelector('[data-thumbnail-fallback]');
    if (image) {
      const fallback = () => {
        if (!image.dataset.thumbnailFallback) return;
        const url = image.dataset.thumbnailFallback;
        delete image.dataset.thumbnailFallback;
        image.src = url;
      };
      image.addEventListener('error', fallback, { once: true });
      image.addEventListener('load', () => { if (image.naturalWidth < 200) fallback(); });
      if (image.complete && image.naturalWidth < 200) fallback();
    }
    link.addEventListener('click', (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      const iframe = template.content.querySelector('iframe')?.cloneNode(true);
      if (!iframe) return;
      event.preventDefault();
      preview.replaceChildren(iframe);
      iframe.focus({ preventScroll: true });
    });
  };

  const pauseSlide = (slide) => {
    if (!slide) return;

    slide.querySelectorAll('video').forEach((video) => {
      video.currentTime = 0;
      video.pause();
    });
    slide.querySelectorAll('[data-story-video-wrap]').forEach((wrap) => wrap.classList.remove('is-playing'));
    slide.querySelectorAll('iframe').forEach((iframe) => {
      if (!iframe.contentWindow) return;

      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
      iframe.contentWindow.postMessage({ method: 'pause' }, '*');
    });
  };

  const initializeSlider = (root) => {
    if (!root || root.dataset.tutorialVideoInitialized === 'true') return;

    const track = root.querySelector('[data-tutorial-video-track]');
    const slides = Array.from(root.querySelectorAll('[data-tutorial-video-slide]'));
    const previous = root.querySelector('[data-tutorial-video-prev]');
    const next = root.querySelector('[data-tutorial-video-next]');

    if (!track || !slides.length) return;

    root.dataset.tutorialVideoInitialized = 'true';
    let activeIndex = 0;

    const show = (nextIndex) => {
      const normalizedIndex = (nextIndex + slides.length) % slides.length;

      if (normalizedIndex !== activeIndex) pauseSlide(slides[activeIndex]);

      activeIndex = normalizedIndex;

      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
    };

    previous?.addEventListener('click', () => show(activeIndex - 1));
    next?.addEventListener('click', () => show(activeIndex + 1));

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(activeIndex - 1);
      if (event.key === 'ArrowRight') show(activeIndex + 1);
    });

    show(0);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-tutorial-youtube]').forEach(initializePreview);
    if (scope.matches?.(ROOT_SELECTOR)) initializeSlider(scope);
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initializeSlider);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
